import gql from "graphql-tag";

export const DISTRIBUTOR_FRAGMENT = gql`
  fragment distributorFragment on Distributor {
    codigoDistribuidor
    codigoEmpleado
    codigoProveedorHesa
    cif
    poblacion
    provincia
    razonSocial
    direccionFiscal
    codigoPostal
    gerente
    email
    erp
    modifEn
    user
    password
    observaciones
    last_login,
    last_transmission_articulos,
    last_transmission_clientes,
    last_transmission_existencias,
    last_transmission_ventas,
    record_type_counts_articulos,
    record_type_counts_clientes,
    record_type_counts_existencias,
    record_type_counts_ventas,
    
    nombreAutorizacionTransNext
  }
`;

export const ALL_DISTRIBUTORS = gql`
  query allDistributors {
    Distributor: allDistributors {
      ...distributorFragment
    }
  }
  ${DISTRIBUTOR_FRAGMENT}
`;

export const CREATE_DISTRIBUTORS = gql`
  mutation createDistributor(
    $codigoDistribuidor: Long!
    $codigoProveedorHesa: String
    $cif: String
    $poblacion: String
    $provincia: String
    $razonSocial: String
    $direccionFiscal: String
    $codigoPostal: String
    $gerente: String
    $email: String!
    $erp: String
    $user: String
    $password: String
    $observaciones: String
  ) {
    Distributor: createDistributor(
      codigoDistribuidor: $codigoDistribuidor
      cif: $cif
      poblacion: $poblacion
      provincia: $provincia
      razonSocial: $razonSocial
      direccionFiscal: $direccionFiscal
      codigoPostal: $codigoPostal
      codigoProveedorHesa: $codigoProveedorHesa
      gerente: $gerente
      email: $email
      erp: $erp
      user: $user
      password: $password
      observaciones: $observaciones
    ) {
      ...distributorFragment
    }
  }
  ${DISTRIBUTOR_FRAGMENT}
`;

export const EDIT_DISTRIBUTORS = gql`
  mutation editDistributor(
    $codigoDistribuidor: Long!
    $codigoEmpleado: Long!
    $codigoProveedorHesa: String
    $cif: String
    $poblacion: String
    $provincia: String
    $razonSocial: String
    $direccionFiscal: String
    $codigoPostal: String
    $gerente: String
    $email: String!
    $erp: String
    $user: String
    $password: String
    $observaciones: String
  ) {
    Distributor: editDistributor(
      codigoDistribuidor: $codigoDistribuidor
      codigoEmpleado: $codigoEmpleado
      codigoProveedorHesa: $codigoProveedorHesa
      cif: $cif
      poblacion: $poblacion
      provincia: $provincia
      razonSocial: $razonSocial
      direccionFiscal: $direccionFiscal
      codigoPostal: $codigoPostal
      gerente: $gerente
      email: $email
      erp: $erp
      user: $user
      password: $password
      observaciones: $observaciones
    ) {
      ...distributorFragment
    }
  }
  ${DISTRIBUTOR_FRAGMENT}
`;

export const FREEZE_DISTRIBUTOR = gql`
  mutation freezeDistributor(
    $codDistribuidor: Long!
  ) {
    Distributor: freezeDistributor(
      codDistribuidor: $codDistribuidor
    ) {
      ...distributorFragment
    }
  }
  ${DISTRIBUTOR_FRAGMENT}
`;

export const UNFREEZE_DISTRIBUTOR = gql`
  mutation unfreezeDistributor(
    $codDistribuidor: Long!
  ) {
    Distributor: unfreezeDistributor(
      codDistribuidor: $codDistribuidor
    ) {
      ...distributorFragment
    }
  }
  ${DISTRIBUTOR_FRAGMENT}
`;
